import React, { memo, useEffect } from 'react'
import { RootState } from './stores/store'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useNavigate } from 'react-router-dom'
import { UserState, viewAsGuest } from './stores/slices/current-user-slice'

type Props = {
    
}

const LogoutHandler: React.FC<Props> = memo((props: Props) => {
    const currentState = useSelector((state: RootState) => state.user.userState)

    const dispatch = useDispatch()

    const navigate = useNavigate();

    useEffect(() => {
        if(currentState === UserState.TokenExpired){
            navigate('/login', { replace: true });
            dispatch(viewAsGuest())
        }
    }, [currentState, navigate, dispatch])

    return (
        <Outlet />
    )
})

export default LogoutHandler